import React from "react";
import { ApplicationOfTheCertificate } from "./components/applicationOfTheCertificate";
import { Certificate } from "./components/certificate";
import { CertificateBenefits } from "./components/certificateBenefits";
import { TypesOfTransactions } from "./components/typesOfTransactions";
import { FooterOrange } from "../../common/FooterOrange/FooterOrange";

import styles from "./style.module.css";
import { ApplicationOfTheCertificate2 } from "./components/applicationOfTheCertificate2";
import { CertificateBenefits2 } from "./components/certificateBenefits2";
import { BoursTable } from "./components/boursTable";
import LineOrange from "../../common/LineOrange/LineOrange";

export const SupplyAndAcceptance = () => {
  return (
    <>
      <Certificate />
      <ApplicationOfTheCertificate />
      <CertificateBenefits />
      <ApplicationOfTheCertificate2 />
      <CertificateBenefits2 />
      <TypesOfTransactions />
      <BoursTable />
      <>
        <div
          className="container pt-2 pb-2 mb-5"
          style={{ backgroundColor: "#F2F4F6", borderRadius: "40px" }}
        >
          <div className="text-center mb-5 mt-5">
            {/* <p style={{ fontSize: "28px", fontWeight: "800" }}>همراه‌تریدر</p> */}
            <h3>مدارک و مستندات لازم جهت عرضه سهام به بورس </h3>
            <LineOrange />

            <div className="">
              <p className="text-right mt-3" style={{ lineHeight: "40px" }}>
                <br /> • پرسشنامه پذیرش: تمامی موارد و بخش‌های پرسش‌نامه بایستی
                براساس اطلاعات جاری یا آخرین سال مالی شرکت تکمیل و به همراه
                مستندات تکمیلی ارایه شود. مضامين پرسش‌نامه، اطلاعات عمومي و
                اختصاصي متقاضی را در بر می‌گیرد. <br /> • امیدنامه: در امیدنامه
                شرکت‌ها باید ابتدا چکیده‌ای از نوع فعالیت شرکت، محل شرکت، تاریخ
                و شماره ثبت شرکت بیان شود. بعد از چکیده فهرست مطالبی که قرار است
                بیان شود به ترتیب زیر مطرح می‌شود: مقدمه/ معرفی شرکت /
                تاریخچه‌ای از شرکت / موضوع فعالیت شرکت / سهامداران / مدیران /
                ساختار نیروی انسانی. <br /> • مرکزاصلی و شعب شرکت به‌طور کامل
                همراه با جداول مربوطه تشریح شود.
                <br /> • در مورد نحوه فعالیت شرکت مواردی از قبیل: محل فعالیت
                اصلی شرکت، دارایی‌های ثابت، محصولات، ظرفیت تولید(اسمی،حقیقی)،
                مواد اولیه ومنابع تامین مالی آن، بازار محصولات و رقبا و برنامه
                های آتی شرکت (مربوط به طرح های توسعه شرکت) ذکرشود. <br /> •
                همچنین اگر شرکت تولیدی باشد اطلاعاتی در مورد تولید و فروش که
                شامل: تولید واقعی، ترکیب بهای تمام شده،تغییرات نرخ مواد اولیه،
                فروش، نحوه قیمت گذاری و فروش محصولات. به‌طور مثال در مورد شرکت
                فولاد مبارکه اصفهان فروش به صورت اعتبار اسنادی داخلی(ریال) و
                یافروش درصدی از محصولات از طریق بورس یا در صدی در شرکت در اتاق
                پایاپای صورت گرفته، عنوان می‌شود. <br /> • رسید پرداخت حق پذیرش:
                حق پذیرش شرکتها معادل ۰.۰۰۲ سرمایه ثبت شده تا سقف ۵۰۰ میلیون
                ریال. <br /> • صورت‌های مالی سالانه مربوط به حداقل سه دورۀ مالی
                منتهی به تاریخ پذیرش که حداقل دو دوره آن برابر یك سال باشد، به
                همراه گزارش حسابرس و بازرس قانونی به تشخیص بورس. <br /> • ارائه
                آخرین صورت های مالی میان دور های شامل صورت های مالی شش ماهۀ
                حسابرسی شده و صورت های مالی سه ماهه. <br /> • گزارش تفسیری
                مدیریت حسابرسی شده. <br /> • گزارش هیئت مدیره به مجامع عمومی
                عادی و فوق العاده حداقل برای دو دورۀ مالی اخیر. <br /> • صور
                تجلسات مجامع عمومی برای حداقل دو سال اخیر و روزنامه های رسمی
                مربوط به آگهی آنها در صورت وجود الزام قانونی. <br /> • برنامه
                کسب و کار (Business Plan) ، مصوب هیئت مدیرۀ شرکت، برای حداقل سه
                سال آینده و براساس فر مهای بورس. <br /> • آخرین اساسنامه، که
                کلیه تغییرات قبلی مصوب مجامع عمومی فوق العاده در آن اعمال شده
                باشد. <br /> • هرگونه تغییرات در اساسنامه طی دو سال مالی اخیر
                مندرج در روزنامه رسمی و آگهی های مربوط به تأسیس و ثبت شرکت.{" "}
                <br /> • فهرست و مشخصات دارندگان اطلاعات نهانی شرکت، موضوع تبصره
                یك ماده 46 قانون بازار اوراق بهادار براساس فرم های سازمان.{" "}
                <br /> • برگه‌های قطعی یا تشخیص مالیات بر عملکرد و ارزش افزوده
                در پنج سال گذشته. <br /> • مصوبه مجمع عمومی عادی صاحبان سهام یا
                رکن مشابه مبنی بر موافقت با پذیرش اوراق بهادار در بورس. <br /> •
                تأییدیه حسابرس در خصوص کفایت سیستم کنترل های داخلی شرکت به نحوی
                که این سیستم متضمن حفظ و رعایت حقوق و منافع سهامداران به صورت
                یکسان باشد. <br /> • آخرین نمودار سازمانی مصوب به همراه شرح
                مختصری از ساختار نیروی انسانی. <br /> • تصویر آخرین پروانه
                فعالیت/ بهره برداری. <br /> • سیاست تقسیم سود پیشنهادی هیئت
                مدیره برای سال مالی جاری و آتی. <br /> • قراردادهای منعقد شده
                متقاضی با مشاور پذیرش و قرارداد فی مابین مشاور پذیرش و مشاور
                حقوقی. <br /> • گزارش ارزش گذاری تهیه شده توسط متعهد خرید به
                درخواست بورس، در صورتی که مبنای پذیرش متقاضی در هر یك از بازارها
                براساس ارزش بازار یا ارزش بازار سهام شناور آزاد باشد. <br /> •
                گزارشی از کلیه دعاوی قضایی در جریان و مختومه له یا علیه شرکت طی
                سه سال اخیر به انضمام نسخه ای از آراء صادره.
              </p>
              <div className={styles.btnWhy}>
                <a
                  type="submit"
                  href="https://mobincrowd.ir/"
                  target="_blank"
                  rel="noreferrer"
                >
                  مبین کراد{" "}
                </a>
                <a
                  type="submit"
                  href="https://www.tse.ir/cms/Systems"
                  target="_blank"
                  rel="noreferrer"
                >
                  فرم های پذیرش در بورس{" "}
                </a>
                <a
                  type="submit"
                  href="https://www.ifb.ir/cms.aspx?tabId=230"
                  target="_blank"
                  rel="noreferrer"
                >
                  فرم های پذیرش در فرابورس{" "}
                </a>
              </div>
            </div>
          </div>
        </div>
      </>
      {/* <FooterOrange
        text={"معاملات گواهی سپرده از طریق سامانه معاملاتی اسمارت ممکن است"}
        btn={"#ff5f00"}
        color={"white"}
        href={"https://smartpro.mobinsb.ir/"}
      /> */}
    </>
  );
};
